import { useLayoutEffect, useSyncExternalStore, type DependencyList } from 'react';
import { prefersReducedMotion, stopAll, subscribeReducedMotion } from './play.js';

/** True when the person asked their system for less motion. Animations then show their still frame. */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribeReducedMotion, prefersReducedMotion, () => false);
}

/**
 * Runs `start` after layout (so refs are set) unless motion is reduced or `still` is set, and cancels
 * whatever it started on unmount or when the deps change. `start` returns the animations it began.
 */
export function useMotion(start: () => readonly (Animation | null)[], deps: DependencyList, still = false): boolean {
  const reduced = useReducedMotion();
  const off = reduced || still;
  useLayoutEffect(() => {
    if (off) return;
    const running = start();
    return () => stopAll(running);
    // The caller lists what restarts the motion.
  }, [off, ...deps]);
  return off;
}
